import React from "react";
import { arrayOf, object, number } from "prop-types";
import { CloudinaryImageAdapter } from "../../CloudinaryImageAdapter/CloudinaryImageAdapter";
import { Cell, Row } from "../../Grid";
import { ComponentsSlider } from "../../ComponentsSlider";
import { HotelBrandCard } from "../HotelBrandCard";

import * as styles from "./BrandsCarousel.module.scss";

const getBreakpoints = slidesPerView => {
	switch (slidesPerView) {
		case 2:
			return {
				320: {
					slidesPerView: 0.999,
					spaceBetween: 16,
				},
				576: {
					slidesPerView: 2,
					spaceBetween: 16,
				},
				769: {
					slidesPerView: 2,
					spaceBetween: 16,
				},
			};
		case 3:
			return {
				320: {
					slidesPerView: 0.999,
					spaceBetween: 16,
				},
				576: {
					slidesPerView: 2,
					spaceBetween: 16,
				},
				769: {
					slidesPerView: 3,
					spaceBetween: 16,
				},
			};
		case 4:
			return {
				320: {
					slidesPerView: 0.999,
					spaceBetween: 16,
				},
				576: {
					slidesPerView: 2,
					spaceBetween: 16,
				},
				769: {
					slidesPerView: 4,
					spaceBetween: 16,
				},
			};
		case 1:
		default:
			return {
				320: {
					slidesPerView: 0.999,
					spaceBetween: 16,
				},
				576: {
					slidesPerView: 1,
					spaceBetween: 16,
				},
				769: {
					slidesPerView: 1,
					spaceBetween: 16,
				},
			};
	}
};

const Slide = ({ entries }) => (
	<Row cols="brand" className={styles.brandsCarouselContainer}>
		{entries &&
			entries.map(entry => (
				<Cell key={entry.id} className={styles.brandItem}>
					<div className={styles.brandsCarouselItem}>
						<HotelBrandCard
							logo={CloudinaryImageAdapter(entry?.logo?.[0])}
							chainName={entry.chainName}
							classNames={styles.cardContainer}
							link={`/${entry?.node_locale?.substr(0, 2)}/hotels/hotel-brands/${entry?.slug ?? ""}`}
						/>
					</div>
				</Cell>
			))}
	</Row>
);

const BrandsCarousel = ({ slides, totalItem, entriesPerPage }) => (
	<div className={styles.brandsCarouselContainer}>
		<ComponentsSlider
			slidesPerView={1}
			breakpoints={getBreakpoints(1)}
			navigationType="hide"
			paginationType="hide"
			linkIcon={true}
			totalItem={totalItem}
			useComponentPagination={true}
			entriesPerPage={entriesPerPage}
			classNames={{
				pagination: styles.pagination,
				swiper: styles.swiper,
				swiperContainer: styles.swiperContainer,
				paddingForNavigationButton: styles.paddingForNavigationButton,
				grid: styles.grid,
			}}
			slides={slides.map((slide, index) => ({
				id: index + 1,
				view: <Slide entries={slide} />,
			}))}
		/>
	</div>
);

BrandsCarousel.propTypes = {
	slides: arrayOf(arrayOf(object)).isRequired,
	totalItem: number.isRequired,
	entriesPerPage: number.isRequired,
};

Slide.propTypes = {
	entries: arrayOf(object).isRequired,
};

export default BrandsCarousel;
export { BrandsCarousel };
